// extracted by mini-css-extract-plugin
export default {"paginationButton":"pagination_paginationButton__XOax5"};